import { createRouter, createWebHashHistory } from "vue-router";
import App from "./App.vue";

const routes = [
  {
    path: "/",
    name: "/",
    component: () => import("./pages/external/External.vue"),
  },
  {
    path: "/system",
    name: "app",
    component: App,
    children: [
      {
        path: "",
        name: "dashboard",
        component: () => import("./pages/main/Home.vue"),
      },
      {
        path: "/operadores",
        name: "operadores",
        component: () => import("./pages/operator/Operator.vue"),
      },
      {
        path: "/registrar-solicitacao",
        name: "registrar-solicitacao",
        component: () =>
          import("./pages/register_solicitation/RegisterSolicitation.vue"),
      },
      {
        path: "/finalizar-solicitacao",
        name: "finalizar-solicitacao",
        component: () =>
          import("./pages/finalize_solicitation/FinalizeSolicitation.vue"),
      },
      {
        path: "/consultar-solicitacao",
        name: "consultar-solicitacao",
        component: () =>
          import("./pages/consult_solicitation/ConsultSolicitation.vue"),
      },
    ],
  },
  {
    path: "/pdf-os",
    name: "external",
    component: () => import("./pages/finalize_solicitation/PdfOs.vue"),
  },
  {
    path: "/acesso-negado",
    name: "acesso-negado",
    component: () => import("./pages/access/AccessDenied.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
